<template>
	<section>
		<h2>Costos</h2>

			<b-row>
				<b-col class="table-responsive">
					<b-table striped hover :items="itemsPrices" :fields="fieldsPrices">
						<template #thead-top="">
							<b-tr>
								<b-th></b-th>
								<b-th></b-th>
								<b-th></b-th>
								<b-th :variant="variantsByTotal.booking"  class="text-right">Precio Venta</b-th>
								<b-th :variant="variantsByTotal.net"  class="text-right">Precio Tarifa</b-th>
								<b-th :variant="variantsByTotal.supplier"  class="text-right">Precio proveedor</b-th>

							</b-tr>
						</template>

						<template #cell(paymentStatus)="row">
							{{$root.getItemFromAuxVarOpts("transportServicePaymentStatusOpts",row.item.paymentStatus).text}}
						</template>
						<template #cell(btnEditPrice)>
							<small class="text-success" v-if="$hasPermission('reservation.cost.edit')">Editable</small>
							<small v-else class="text-danger">Ya se encuentra seleccionado en un pago</small>
						</template>
						<template #cell(lblBookingPriceTotal)="row">
							<div class="d-flex flex-row justify-content-end">
								<div>
									<span>{{row.item.lblBookingPriceTotal}}</span>
									<div><small>{{row.item.bookingPriceOverride ? '(Mantener precio)' : ''}}</small></div>
								</div>
								<md-icon
									v-if="$hasPermission('reservation.cost.edit')"
									@click.native="openEditPrice(row.item.id, 'booking')"
									class="ml-2 text-info edit-icon"
									icon="edit"></md-icon>
							</div>
						</template>
						<template #cell(lblNetPriceTotal)="row">
							<div class="d-flex flex-row justify-content-end">
								<div>
									<span>{{row.item.lblNetPriceTotal}}</span>
									<div><small>{{row.item.netPriceOverride ? '(Mantener precio)' : ''}}</small></div>
								</div>
								<md-icon
									v-if="$hasPermission('reservation.cost.edit')"
									@click.native="openEditPrice(row.item.id, 'net')"
									class="ml-2 text-info edit-icon"
									icon="edit"></md-icon>
							</div>
						</template>
						<template #cell(lblSupplierPriceTotal)="row">
							<div class="d-flex flex-row justify-content-end">
								<div>
									<span>{{row.item.lblSupplierPriceTotal}}</span>
									<div><small>{{row.item.supplierPriceOverride ? '(Mantener precio)' : ''}}</small></div>
								</div>
								<md-icon
									v-if="$hasPermission('reservation.cost.edit')"
									@click.native="openEditPrice(row.item.id, 'supplier')"
									class="ml-2 text-info edit-icon"
									icon="edit"></md-icon>
							</div>
						</template>
						<template #custom-foot>
							<b-tr>
								<b-th></b-th>
								<b-th></b-th>
								<b-th></b-th>
								<b-th :variant="variantsByTotal.booking" class="text-right pb-0">
									<p class="mt-1" v-for="(item, i) of totalsBooking" :key="i">
										{{formatLblPrice(item.total,item.currency)}}
									</p>
								</b-th>
								<b-th :variant="variantsByTotal.net"  class="text-right pb-0">
									<p class="mt-1" v-for="(item, i) of totalsNet" :key="i">
										{{formatLblPrice(item.total,item.currency)}}
									</p>
								</b-th>
								<b-th :variant="variantsByTotal.supplier" class="text-right pb-0">
									<p class="mt-1" v-for="(item, i) of totalsSupplier" :key="i">
										{{formatLblPrice(item.total,item.currency)}}
									</p>
								</b-th>

							</b-tr>
						</template>
					</b-table>
				</b-col>
			</b-row>

		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-modal
		size="lg"
		scrollable
		no-fade
		:title="`Editar ${type[formType]}`"
		ref="modal-edit-price"
		body-class="position-static"
		hide-footer
		no-close-on-backdrop
		>
			<form-edit-price
			:type="type"
			:transportServiceId="transportServiceId"
			:formType="formType"
			@saved="saved"
			/>
		</b-modal>
	</section>
</template>

<script>
	import api from '../../../api.js'
	import numeral from 'numeral'
	import formEditPrice from "./FormEditPrice.vue"
	import { mapActions } from "vuex";
	export default {
		components: {formEditPrice  },
		props: {
			modelId: {
				type : Number,
				required: true,
			}
		},
		data(){
			return {
				type: {
					booking: 'Precio de venta',
					net: 'Precio tarifa',
					supplier: 'Precio proveedor'
				},
				formType: null,
				transportServices:[],
				loading:true,
				totalTypes:["booking","net","supplier"],
				variantsByTotal:{booking:"success",net:"primary",supplier:"info"},
				transportServiceId:-1
			}
		},
		computed : {
			fieldsPrices(){
				let fields = [
					{label:"# Servicio",key:"serviceNumber"},
					{label:"Status pago",key:"paymentStatus"},
					{label:"Status",key:"btnEditPrice",class:"text-right"},
					{label:"Total c/imp",key:"lblBookingPriceTotal",class:"text-right"},
					{label:"Total c/imp",key:"lblNetPriceTotal",class:"text-right"},
					{label:"Total c/imp",key:"lblSupplierPriceTotal",class:"text-right"},
				];
				if(!this.$hasPermission('reservation.specialRate')){
					let indexToDelete = fields.findIndex((item)=>{return item.key=='btnEditPrice'})
					fields.splice(indexToDelete,1);
				}

				return fields;
			},
			itemsPrices(){
				let items = [];
				this.transportServices.forEach((ts)=>{
					let toAdd       = {
						lblBookingPriceSubtotal   :this.formatLblPrice(ts.bookingPriceSubtotal,ts.bookingCurrency),
						lblBookingPriceTotal      :this.formatLblPrice(ts.bookingPriceTotal,ts.bookingCurrency),
						lblNetPriceSubtotal       :this.formatLblPrice(ts.netPriceSubtotal,ts.netCurrency),
						lblNetPriceTotal          :this.formatLblPrice(ts.netPriceTotal,ts.netCurrency),
						lblSupplierPriceSubtotal  :this.formatLblPrice(ts.supplierPriceSubtotal,ts.supplierCurrency),
						lblSupplierPriceTotal	  :this.formatLblPrice(ts.supplierPriceTotal,ts.supplierCurrency),
					}
					let item =  {...ts,...toAdd}
					items.push(item)
				})
				return items;
			},
			totalsByCurrency(){//sacamos el total por currency
				let info   = {booking:{},net:{},supplier:{}};

				this.totalTypes.forEach((_type)=>{
					this.transportServices.forEach((ts)=>{
						let tsCurrency = ts[`${_type}Currency`].toLowerCase();
						if(info[_type][tsCurrency]===undefined){
							info[_type][tsCurrency]= {//se iniciliza el index
								currency:`${tsCurrency}`,
								// subtotal:0,
								total:0
							};
						}
						// info[_type][tsCurrency].subtotal = info[_type][tsCurrency].subtotal+=Number(ts[`${_type}PriceSubtotal`]);
						info[_type][tsCurrency].total    = info[_type][tsCurrency].total+=Number(ts[`${_type}PriceTotal`]);
					})
				})

				let result = {};
				this.totalTypes.forEach((_type)=>{
					result[_type] = Object.values(info[_type]);
				})
				return result;
			},
			totalsBooking(){
				return this.totalsByCurrency.booking;
			},
			totalsNet(){
				return this.totalsByCurrency.net;
			},
			totalsSupplier(){
				return this.totalsByCurrency.supplier;
			},/*
			colspanBookingPrice(){
				let colspan =  ((this.$hasPermission('reservation.specialPrice'))?'3':'2');
				return colspan
			} */
		},
		methods:{
			...mapActions("reservation", ["_fetchNotes"]),
			fetchModel(){
				this.loading = true
				api(this).get(`/reservations/prices-summary/${this.modelId}`).then( res => {
					this.transportServices = Array.isArray(res.data) ? [...res.data] : [...res.data.transportServices]
					this.loading = false
				}).catch(this.$root.handleRequestError);
			},
			formatLblPrice(price,currency){
				let priceF =  numeral(price).format('0,0.[00]');
				return "$"+priceF +" "+(currency.toUpperCase())

			},
			openEditPrice(transportServiceId, type){
				this.transportServiceId = transportServiceId;
				this.formType = type
				this.$refs["modal-edit-price"].show();
			},
			closeEditPrice(){
				this.$refs["modal-edit-price"].hide();
			},
			saved(){
				this.closeEditPrice();
				this.fetchModel()
				this._fetchNotes({ context: this, modelId: this.modelId });

			}

		},
		mounted(){
			this.fetchModel()

		}
	}
</script>

<style scoped>
	.price-input{
		width: 40px;
	}
	.edit-icon {
		cursor: pointer;
	}
</style>
